/**
 * jobsApi.js
 * ----------
 * Shared API client for the Universal Background Job Engine.
 * Used by useExportJob, useBulkImportJob, and any future job type.
 */
import api from './client'

/**
 * Enqueue a background job.
 * Returns { jobId, status: 'QUEUED', message }
 */
export async function enqueueJob({ module, jobType = 'EXPORT', fileFormat = 'CSV', payload = {} }) {
  const { data } = await api.post('/api/jobs/', {
    module,
    job_type: jobType,
    file_format: fileFormat,
    payload,
  })
  return data
}

/**
 * Poll job status by ID.
 * Returns { jobId, status, progressPct, fileName, downloadUrl, errorMessage, ... }
 */
export async function getJobStatus(jobId) {
  const { data } = await api.get(`/api/jobs/${jobId}`)
  return data
}

/**
 * Return absolute download URL for a completed job (browser-native download).
 * Uses the backend token in the Authorization header — handled by FileResponse.
 */
export function getJobDownloadUrl(jobId) {
  return `/api/jobs/${jobId}/download`
}

/**
 * List the current user's recent background jobs.
 * Returns { items: [...] }
 */
export async function listMyJobs(limit = 30) {
  const { data } = await api.get('/api/jobs/history', { params: { limit } })
  return data
}

/**
 * Download a completed job file as a blob and trigger browser download.
 */
export async function downloadJobFile(jobId, fileName = 'export.csv') {
  const { data } = await api.get(`/api/jobs/${jobId}/download`, {
    responseType: 'blob',
  })
  const url = URL.createObjectURL(data)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  link.click()
  URL.revokeObjectURL(url)
}
